type Props = { live?: number };

export const AIDots = ({ live = 3 }: Props) => (
  <span className="tp-ai-dots" aria-label={`AI ${live} of 3`}>
    <span className="on">{"●".repeat(live)}</span>
    <span className="off">{"●".repeat(3 - live)}</span>
  </span>
);
